import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/icon_new.svg'


const _hoisted_1 = { class: "p-result__list" }
const _hoisted_2 = {
  key: 0,
  class: "p-result__lecture"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 0,
  class: "p-result__new",
  src: _imports_0,
  alt: "NEW"
}
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "p-result__description" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "p-result__teacher" }
const _hoisted_9 = {
  key: 0,
  class: "p-result__gakumon"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 0,
  class: "p-result__word"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("dt", null, "関心ワード：", -1)
const _hoisted_14 = {
  key: 2,
  class: "p-result__SDGs"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("dt", null, "関連するSDGs：", -1)
const _hoisted_16 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.searchResults)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (result) => {
            return (_openBlock(), _createElementBlock("li", {
              key: result.genkocode
            }, [
              _createElementVNode("a", {
                class: "p-result__img",
                href: "lecture.html?gnkcd="+result.genkocode+_ctx.lectureParam
              }, [
                _createElementVNode("figure", null, [
                  (result.isnew)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                    : _createCommentVNode("", true),
                  _createElementVNode("img", {
                    src: `${_ctx.consts.yumenaviinfo}tm_web/common/images/image_holder.png`,
                    alt: result.title,
                    style: _normalizeStyle(`background-image: url(${result.image})`)
                  }, null, 12, _hoisted_5)
                ])
              ], 8, _hoisted_3),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("a", {
                  class: "p-result__title",
                  href: "lecture.html?gnkcd="+result.genkocode+_ctx.lectureParam
                }, [
                  _createElementVNode("h3", null, _toDisplayString(result.title), 1)
                ], 8, _hoisted_7),
                _createElementVNode("p", _hoisted_8, [
                  _createElementVNode("span", null, _toDisplayString(result.daigakuname) + " " + _toDisplayString(result.gakubu) + " " + _toDisplayString(result.gakka), 1),
                  _createElementVNode("span", null, _toDisplayString(result.gakui) + " " + _toDisplayString(result.kyojuname) + " 先生", 1)
                ]),
                (result.gakumonbunyas)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(result.gakumonbunyas, (gakumon) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (gakumon.code != 'gc400')
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                class: _normalizeClass(["c-gakumon", "c-"+gakumon.groupcode]),
                                href: "./gakumon.html?cd="+gakumon.code,
                                target: "_blank"
                              }, _toDisplayString(gakumon.name), 11, _hoisted_10))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: _normalizeClass(["c-gakumon c-gakumonnolink", "c-"+gakumon.groupcode]),
                                href: "./gakumon.html?cd="+gakumon.code,
                                target: "_blank"
                              }, _toDisplayString(gakumon.name), 11, _hoisted_11))
                        ], 64))
                      }), 256))
                    ]))
                  : _createCommentVNode("", true),
                (result.kanshinwords)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (result.kanshinwords.length > 0)
                        ? (_openBlock(), _createElementBlock("dl", _hoisted_12, [
                            _hoisted_13,
                            _createElementVNode("dd", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(result.kanshinwords, (word) => {
                                return (_openBlock(), _createElementBlock("span", null, _toDisplayString(_ctx.abc123ToHAN(word)), 1))
                              }), 256))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (result.sdgs)
                  ? (_openBlock(), _createElementBlock("dl", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("dd", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(result.sdgs, (sdg) => {
                          return (_openBlock(), _createElementBlock("a", {
                            class: _normalizeClass(["c-SDGs", "c-SDGs-type"+sdg]),
                            href: `${_ctx.consts.telemail}shingaku/p/sdgs_kaisetu/goal_detail.php?SDGS=`+sdg,
                            target: "_blank"
                          }, null, 10, _hoisted_16))
                        }), 256))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}